import React, { useEffect } from 'react'

import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { Icon } from '@driftt/tide-icons'

import { JobDesignationStep } from 'layouts/JobDesignationStep'
import NotificationsStep from 'layouts/NotificationsStep'
import PasswordStep from 'layouts/PasswordStep'
import ProfilePhotoStep from 'layouts/ProfilePhotoStep'
import SetupProgress from 'layouts/SetupProgress'
import { SignUpStep } from 'layouts/SignUpStep'
import ThirdPartyLandingPage from 'layouts/ThirdPartyLandingPage'
import * as MetricsActions from 'modules/metrics/actions'
import * as UserSelectors from 'modules/user/selectors'
import { countAppMetric } from 'utils/metrics'
import { track } from 'utils/trackingUtils'

const InviteFlowController = ({ flow, hasSocialInvite, actions }) => {
  useEffect(() => {
    if (flow && actions) {
      track('Invited User Flow Started', { flow })
      actions.sendDriftAppMetric(
        countAppMetric(`invitedUserFlow.started.${flow}`, 'onboarding.')
      )

      window.drift && window.drift.hide()
      window.HelpLauncher && window.HelpLauncher.hide()
    }
  }, [flow, actions])

  return (
    <React.Fragment>
      <div className="setup-container">
        <div className="setup-container-fields-wrapper">
          <div className="setup-container-fields">
            <Icon
              className="setup-container-drift-logo"
              name="drift-logo-full"
            />
            <SetupProgress />
            <Switch>
              <Route exact path="/invite">
                {hasSocialInvite ? (
                  <Redirect to="/invite/signin" />
                ) : (
                  <Redirect to="/invite/profile" />
                )}
              </Route>
              <Route path={'/invite/signin'} component={SignUpStep} />
              <Route path={'/invite/profile'} component={ProfilePhotoStep} />
              <Route path={'/invite/password'} component={PasswordStep} />
              <Route
                path={'/invite/notifications'}
                component={NotificationsStep}
              />
              <Route
                path={'/invite/personalize'}
                component={JobDesignationStep}
              />
              <Route
                path={'/invite/signup/google'}
                component={ThirdPartyLandingPage}
              />
              <Route
                path={'/invite/signup/microsoft'}
                component={ThirdPartyLandingPage}
              />
            </Switch>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  flow: UserSelectors.getFlow(state),
  hasSocialInvite: UserSelectors.getHasSocialInvite(state),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      sendDriftAppMetric: MetricsActions.sendDriftAppMetric,
    },
    dispatch
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InviteFlowController)
